import React from 'react';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  blogPageAdditionalMeta,
  blogPageStructuredData,
} from '../../utils/data/MetaData';
// Images
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import BlogPageMainContainer from '../../components/blog/BlogPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function BlogPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Blog'
        desc={`News from ${CompanyName}: session availability, tour dates, clip sales and updates from the Submission Suite in Oldbury, West Midlands, and beyond.`}
        keywords={KeywordsPages}
        additionalMeta={blogPageAdditionalMeta}
        structuredData={blogPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid w-full px-6 sm:px-8 md:px-12 lg:container lg:mx-auto py-10'>
            <section className='text-center'>
              <h1 className='font-StencilW01 text-[2.5rem] xs:text-5xl md:text-6xl lg:text-8xl xl:text-9xl text-colour5 font-medium tracking-widest uppercase'>
                MY BLOG
              </h1>
              <h2 className='text-lg'>STAY UP TO DATE WITH NEWS AND TOURS!</h2>
            </section>
          </header>

          {/* Main page content */}
          <BlogPageMainContainer />

          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default BlogPage;
